import { useServicesQuery } from '@/services/api';
import type { ServicesApiGetEnvHealthQueryParams } from '@/services/api/services-api';
import { WORKSPACE_HEALTH_REFETCH_INTERVAL_ACTIVE, WORKSPACE_HEALTH_REFETCH_INTERVAL_IDLE } from '../constants';

/**
 * Fetches workspace health with adaptive polling.
 *
 * @param active - true when the user is on the health page (2 min polling).
 *   When false (e.g. the nav-bar widget), polls at 5 min.
 */
export function useEnvHealth(
  workspaceId: number,
  simulate: ServicesApiGetEnvHealthQueryParams['simulate'],
  active = false,
) {
  return useServicesQuery(
    'getEnvHealth',
    { params: { environment_id: workspaceId }, query: { simulate } },
    {
      refetchInterval: active ? WORKSPACE_HEALTH_REFETCH_INTERVAL_ACTIVE : WORKSPACE_HEALTH_REFETCH_INTERVAL_IDLE,
      enabled: workspaceId > 0,
      refetchOnMount: false,
    },
  );
}
